import { Validators } from "@angular/forms";
import { BasespaceFormControl, BasespaceFormProperties } from "../bs-app-launch-form-control";
import { BsAppLaunchSelectControlComponent } from "./bs-app-launch-select-control.component";

export interface ISelectChoice {
    selected: boolean; 
    text: string; 
    value: any; 
}

export interface SelectFormControlProperties extends BasespaceFormProperties<BsAppLaunchSelectControlComponent> {
    choices: ISelectChoice[];
    togglers: any[];
    multiselect: boolean;
}

// Reference docs: https://dagobah-developer.cloud-test.illumina.com/docs/content/documentation/apptools/formbuilder-overview#Select
// Reference class: src/Cloud.FormBuilder/Models/Select.cs
export class SelectFormControl extends BasespaceFormControl<BsAppLaunchSelectControlComponent> implements SelectFormControlProperties {
    choices: ISelectChoice[];
    togglers: { toggleOnValue: string | number; toggleFields: string | number } [];
    multiselect: boolean;

    constructor(
        data: SelectFormControlProperties
    ) {
        const { 
            id, 
            componentReference, 
            label, 
            helpText,
            size,
            value, 
            required, 
            requiredMessage, 
            choices, 
            togglers,
            multiselect, 
            tabularFieldSetStyling,
            formControlType
        } = data;

        super({ 
            id, 
            componentReference, 
            label, 
            helpText,
            size,
            value, 
            required, 
            requiredMessage, 
            tabularFieldSetStyling,
            formControlType
        });

        this.choices = choices;
        this.togglers = togglers;
        this.multiselect = multiselect;

        if(required) {
            this.setValidators(Validators.required);
        }


        let initialValue = this.choices
            .filter((choice) => !!choice.selected)
            // Value can be number or string
            .map((choice) => choice.value);

        if(!this.multiselect) {
            // The this.choices[0].value default value if all selection options are false is behavior carried over from old UI
            // Not sure if I agree with it but it works for now
            initialValue = initialValue.length > 0 ? initialValue[0] : this.choices[0].value;
        }

        this.setValue(initialValue);
    }

    getRequestEntries(): any[][] {
        if(this.value && Array.isArray(this.value)){
            return this.value.map((value) => {
                return [this.id, value];
            });
        
        // Value for select can be single primitive or array of primitive values for multiselect
        } else if(this.value) {
            return [this.value].map((value) => {
                return [this.id, value];
            });
        } else {
            return [];
        }
    }
    
}